var map = {
	"./1.png": 74056,
	"./10.png": 13178,
	"./2.png": 65782,
	"./3.png": 25443,
	"./4.png": 65053,
	"./5.png": 20759,
	"./6.png": 42249,
	"./7.png": 20466,
	"./8.png": 69274,
	"./9.png": 2967
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36737;